import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-common-pop-up',  
  templateUrl: './common-message.component.html',
  styleUrl: './common-message.component.scss'
,  standalone: false
})
export class CommonMessageComponent {
  constructor(
    public dialogRef: MatDialogRef<CommonMessageComponent>,
    @Inject(MAT_DIALOG_DATA) public message: string) { }

  onConfirm(result: boolean): void {
    this.dialogRef.close(result);
  }
}
